import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { BaseStepComponent } from '../../base';
import { SelectItem } from '../../../../node_modules/primeng/primeng';
import { initDomAdapter } from '../../../../node_modules/@angular/platform-browser/src/browser';
import { TelefoneTipo } from 'app/entity/enumeraveis';
import { comparerStringRepeated, requiredMinLength } from '../../util/custom.validators';

@Component({
  selector: 'telefone',
  templateUrl: './telefone.component.html'
})
export class TelefoneFormComponent extends BaseStepComponent {
  @Input() listaTelefone: any[];
  @Input() profissional:any;
  @Output() listaTelefoneChange = new EventEmitter<any[]>();
  @Input() label: string;
  @Input() cadastrar: boolean = true;
  tiposTelefones: SelectItem[] = [];
  telefoneTipo = TelefoneTipo;
  cadastro = this.formBuilder.group({
    tipo_telefone: [null, [Validators.required]],
    num_telefone: [null, [Validators.required, comparerStringRepeated, requiredMinLength(10)]],
  })
  init() {
    this.loadListAsEnum(this.tiposTelefones, TelefoneTipo);
  }

}



// WEBPACK FOOTER //
// ./src/app/Componentes/telefone/telefone.component.ts